import apiClient from '../utils/axiosClient';

export const loadLatestPerformanceIndicatorsReport = async () => {
  return (await apiClient.get('/reports/performance-indicators'))?.data;
};
